import React from "react";
import MinimalPublicPage from "./MinimalPublicPage";

export default function PricingPage() {
  return (
    <MinimalPublicPage
      eyebrow="Pricing"
      title="Free to start. More control when you need it."
      description="Start on the free tier. Upgrade only when you want deeper queue controls and account advantages."
      points={[
        {
          title: "Free",
          body: "Join the platform, get verified, and start playing without a credit card.",
        },
        {
          title: "Premium",
          body: "Unlock stronger control over maps, regions, and queue preferences.",
        },
        {
          title: "Pro",
          body: "Designed for committed competitors who want the deepest matchmaking control.",
        },
      ]}
      secondaryLabel="How it works"
      secondaryTo="/how-it-works"
    />
  );
}
